<template>
  <div class="ai-compatibility-panel">
    <slot />
    <div v-if="notice || ($slots.actions || $scopedSlots.actions)" class="ai-compatibility-message" :class="{ 'after-content': state === 'partial' || message }" :role="noticeRole">
      <span>{{ notice }}<span v-if="paused">本轮操作已暂停。</span></span>
      <span v-if="($slots.actions || $scopedSlots.actions)" class="ai-notice-actions"><slot name="actions" /></span>
    </div>
  </div>
</template>
<script>
// AI页面文字提示唯一展示入口：message用于普通提示，actions插槽保留重试等交互；
// 兼容提示通过state映射固定文案。仅消费既有判定结果，不决定权限或改变版本规则。
// 新增提示状态时在此集中维护文案/视觉，同时补测试；业务组件不要再写独立升级提示。
const COPY = Object.freeze({
  partial: '当前组件版本较低，可能不支持。',
  unsupported: '不支持此组件，建议更新应用。'
})
export default {
  props: {
    state: { type: String, default: 'supported' },
    message: { type: String, default: '' },
    noticeRole: { type: String, default: 'status' },
    paused: { type: Boolean, default: false }
  },
  computed: { notice() { return this.message || COPY[this.state] || '' } }
}
</script>
<style scoped>
/* 仅追加贴近内容的居中标签，不增加容器背景、内边距或改变原组件宽度。 */
.ai-compatibility-panel { display: contents; }
.ai-compatibility-message {
  display: block;
  width: 100%;
  margin: 0;
  text-align: center;
  color: #737d8d;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  overflow-wrap: anywhere;
}
.ai-compatibility-message.after-content { margin-top: 2px; }
.ai-notice-actions { display: inline-flex; flex-wrap: wrap; justify-content: center; gap: 8px; margin-left: 8px; vertical-align: baseline; }
/* 动作仍由调用方提供事件和禁用条件，样式与提示同行统一。 */
.ai-notice-actions ::v-deep button { font: inherit; color: inherit; background: transparent; border: 0; padding: 0 2px; text-decoration: underline; text-underline-offset: 2px; cursor: pointer; }
.ai-notice-actions ::v-deep button:disabled { opacity: .5; cursor: default; }
</style>
